const FETCH_USER_INCENTIVES = "user/incentives/FETCH_USER_INCENTIVES";
const FETCH_USER_INCENTIVES_SUCCESS =
  "user/incentives/FETCH_USER_INCENTIVES_SUCCESS";
const FETCH_USER_INCENTIVES_FAIL = "user/incentives/FETCH_USER_INCENTIVES_FAIL";
const UPDATE_USER_INCENTIVES = "user/incentives/UPDATE_USER_INCENTIVES";
const UPDATE_USER_INCENTIVES_SUCCESS =
  "user/incentives/UPDATE_USER_INCENTIVES_SUCCESS";
const UPDATE_USER_INCENTIVES_FAIL =
  "user/incentives/UPDATE_USER_INCENTIVES_FAIL";
const SUBMIT_USER_INCENTIVES = "user/incentives/SUBMIT_USER_INCENTIVES";
const SUBMIT_USER_INCENTIVES_SUCCESS =
  "user/incentives/SUBMIT_USER_INCENTIVES_SUCCESS";
const SUBMIT_USER_INCENTIVES_FAIL =
  "user/incentives/SUBMIT_USER_INCENTIVES_FAIL";

const initialState = {
  pending: true,
  loaded: false,
  incentives: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_USER_INCENTIVES:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_USER_INCENTIVES_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        dirty: false,
        oldIncentives: { ...action.results },
        incentives: { ...action.results },
        errors: null
      });
    case FETCH_USER_INCENTIVES_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case UPDATE_USER_INCENTIVES:
      return Object.assign({}, state, {
        dirty: true,
        incentives: action.incentives
      });
    case UPDATE_USER_INCENTIVES_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        incentives: { ...action.results },
        errors: null
      });
    case UPDATE_USER_INCENTIVES_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case SUBMIT_USER_INCENTIVES:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case SUBMIT_USER_INCENTIVES_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        oldIncentives: { ...action.results },
        incentives: { ...action.results },
        dirty: false,
        errors: null
      });
    case SUBMIT_USER_INCENTIVES_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    default:
      return state;
  }
}

export function fetchUserIncentivesPending() {
  return {
    type: FETCH_USER_INCENTIVES
  };
}

export function fetchUserIncentivesSuccess(results) {
  return {
    type: FETCH_USER_INCENTIVES_SUCCESS,
    results
  };
}

export function fetchUserIncentivesFail(errors) {
  return {
    type: FETCH_USER_INCENTIVES_FAIL,
    errors
  };
}

export function updateUserIncentives(incentives) {
  return {
    type: UPDATE_USER_INCENTIVES,
    incentives
  };
}

export function updateUserIncentivesSuccess(results) {
  return {
    type: UPDATE_USER_INCENTIVES_SUCCESS,
    results
  };
}

export function updateUserIncentivesFail(errors) {
  return {
    type: UPDATE_USER_INCENTIVES_FAIL,
    errors
  };
}

export function submitUserIncentivesPending() {
  return {
    type: SUBMIT_USER_INCENTIVES
  };
}

export function submitUserIncentivesSuccess(results) {
  return {
    type: SUBMIT_USER_INCENTIVES_SUCCESS,
    results
  };
}

export function submitUserIncentivesFail(errors) {
  return {
    type: SUBMIT_USER_INCENTIVES_FAIL,
    errors
  };
}

export const getIncentives = state => state.incentives;
export const getValidIncentives = state => state.oldIncentives;
export const getIncentivesError = state => state.errors;
export const getIncentivesPending = state => state.pending;
export const getIncentivesLoaded = state => state.loaded;
export const getIncentivesDirty = state => state.dirty;
